import React, { FC } from 'react';
import { Flex } from 'portal-commons';
import CspDetailsSection from './CspDetailsSection';
import EnablementsSection from './EnablementsSection';
import AccountUsageSection from './AccountUsageSection';
import { CspProfile } from '@/types/user';

interface TabAccountProps {
  profile: CspProfile;
  currentPortalUsers?: number;
  currentBrands?: number;
}

const TabAccount: FC<TabAccountProps> = ({
  profile,
  currentPortalUsers,
  currentBrands,
}) => {
  return (
    <Flex
      sx={{ flexDirection: 'column', rowGap: '32px', mt: '7px' }}
      data-testid="tabAccountContainer"
    >
      <CspDetailsSection
        street={profile?.street}
        ein={profile?.ein}
        city={profile?.city}
        website={profile?.website}
        state={profile?.state}
        stockSymbol={profile?.stockSymbol}
        postalCode={profile?.postalCode}
        stockExchange={profile?.stockExchange}
        country={profile?.country}
        createDate={profile?.createDate}
      />
      <EnablementsSection
        platformFreeTrialEnabled={profile?.platformFreeTrialEnabled}
        ucaasEnabled={profile?.ucaasEnabled}
        soleProprietorEnabled={profile?.soleProprietorEnabled}
        dpaSigned={profile?.dpaSigned}
        migrationSupported={profile?.migrationSupported}
        migrationAutoComplete={profile?.migrationAutoComplete}
      />
      <AccountUsageSection
        currentPortalUsers={currentPortalUsers}
        maxPortalUsers={profile?.maxPortalUsers}
        maxCampaignsPerBrand={profile?.maxCampaignsPerBrand}
        currentBrands={currentBrands}
        maxBrands={profile?.maxBrands}
      />
    </Flex>
  );
};

export default TabAccount;
